module.exports = __webpack_public_path__ + "img/image2 copy 2.4bb649b9.jpg";